import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getUserId, setStakeholderType } from "../../app/api/NOCU/helpers/applicationApiHelpers";
import { getMapTableCounts, getMapTableRecords } from "../../app/api/NOCU/tableAPI";
import { STAKEHOLDERS, STAT_ACCENT_COLORS, STAT_ICON_PATHS } from "../../app/constants";
import { navigateSelf } from "../../app/router/routerManager";
import { ISSUE_ROUTES, TECHNICAL_COMMITTEE_ROUTES } from "../../app/router/routes";
import StatCard from "../../components/cards/statCard";
import LoaderComponent from "../../components/Loader/LoaderComponent";
import HomeTable from "../../components/table/HomeTable";
import { showViewIcon } from "../../components/table/tableHelpers";
import { SectionRow } from "../../layouts/sections";
import { getMapTableData } from "./dataManipulation";
import {
	deleteIsRenewal,
	setIsRenewal,
	setSelectedStatCardOnSession,
} from "../../components/navbar/helpers";
import { Tooltip } from "@mui/material";

const SignatureHome = () => {
	const { id } = useParams();
	const [records, setRecords] = useState();
	const [res, setRes] = useState();
	const [counts, setCounts] = useState({
		pendingCount: 0,
		approvedCount: 0,
		rejectedCount: 0,
		resubmissionCount: 0,
	});
	const [selectedCount, setSelectedCount] = useState();
	const [selectedTitle, setSelectedTitle] = useState("New Requests");
	const [isLoading, setIsLoading] = useState(true);

	const tableHeaders = [
		"Name",

		<Tooltip title={<div className='p-2 text-sm'>System Generated Mapping Number</div>}>
			<div>System No.</div>
		</Tooltip>,
		"Application No.",
		"Registration No.",
		"Contact Person",
		"Date & Time",
		"Type",
	];

	let filters = [
		{ key: "PENDING", value: "PENDING" },
		{ key: "SUCCESS", value: "SUCCESS" },
		{ key: "SUSPENDED", value: "SUSPENDED" },
		{ key: "APPROVED", value: "APPROVED" },
		{ key: "REJECTED", value: "REJECTED" },
	];
	let sorting = [
		{ key: "Acceding", value: true },
		{ key: "Descending", value: false },
	];
	const [selectedStatCard, setSelectedStatCard] = useState(1);
	const [params, setParams] = useState({
		page: 0,
		size: 5,
		applicationNumber: "",
		stakeholderType: "ALL",
		applicationStage: "ISSUE",
		status: "",
		officerId: getUserId(),
		isAscending: true,
	});

	useEffect(() => {
		setSelectedStatCard(parseInt(id));
		if (parseInt(id) === 1) {
			setParams({ ...params, status: "PENDING" });
			setSelectedStatCardOnSession(1);
			setSelectedCount(counts?.pendingCount);
		} else if (parseInt(id) === 2) {
			setSelectedStatCardOnSession(2);
			setParams({ ...params, status: "APPROVED", isAscending: false });
			setSelectedCount(counts?.approvedCount);
		}
	}, [id]);

	const handleStakeHolderType = (filter) => {
		setParams({ ...params, stakeholderType: filter });
	};

	const handleSearchById = (id) => {
		setParams({ ...params, applicationNumber: id });
	};

	const handleSorting = (isAscending) => {
		setParams({ ...params, isAscending: isAscending });
	};
	const handlePage = (page) => {
		setParams({ ...params, page: page });
	};
	const handleSize = (size) => {
		setParams({ ...params, size: size });
	};

	const viewFunction = (index) => {
		setIsRenewal(res.mappedApplicationList[index]?.isRenewal);
		navigateSelf(ISSUE_ROUTES.REVIEW);
	};
	const historyFunction = (index) => {
		console.log("Index Of record=================>", index);
	};

	useEffect(() => {
		deleteIsRenewal();
		const cParams = {
			officerId: getUserId(),
			stakeholderType: params.stakeholderType,
			applicationNumber: params.applicationNumber,
			applicationStage: "ISSUE",
		};
		setStakeholderType(params.stakeholderType);
		getMapTableCounts(cParams).then((res) => {
			setCounts(res);
		});
	}, []);

	useEffect(() => {
		if (parseInt(id) === 1) {
			setSelectedCount(counts?.pendingCount);
		} else if (parseInt(id) === 2) {
			setSelectedCount(counts?.approvedCount);
		}
	}, [counts]);

	useEffect(() => {
		console.log("Params ====>", params);
		if (params.status && params.status !== "") {
			getMapTableRecords(params)
				.then((res) => {
					console.log("Res ======> ", getMapTableData(res.data));
					setRecords(getMapTableData(res.data));
					setRes(res.data);
					setIsLoading(false);
				})
				.then((e) => console.log(e));
		}
	}, [params]);

	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<SectionRow className='mt-0'>
				<span className='overViewTitle'>Signature</span>
			</SectionRow>
			<SectionRow className='w-full overflow-x-auto mb-5 customScrollBar'>
				<SectionRow className='w-full !min-w-max mb-2 justify-center items-center'>
					<StatCard
						value={counts ? counts.pendingCount : 0}
						text={"Pending Application"}
						image={STAT_ICON_PATHS.stat_duplication}
						accent={STAT_ACCENT_COLORS.blue}
						handleStatCard={() => {}}
						num={1}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
					<StatCard
						value={counts ? counts.approvedCount : 0}
						text={"Approved Applications"}
						image={STAT_ICON_PATHS.stat_checkMark}
						accent={STAT_ACCENT_COLORS.lightGreen}
						handleStatCard={() => {}}
						num={2}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
				</SectionRow>
			</SectionRow>
			<HomeTable
				useMappedApplicationNumber
				applicationKey={1}
				columns={tableHeaders}
				rows={records}
				handleSearchById={handleSearchById}
				view={showViewIcon(["1"], id) ? viewFunction : null}
				history={historyFunction}
				filters={STAKEHOLDERS}
				setFilter={handleStakeHolderType}
				// sort={sorting}
				handleSort={handleSorting}
				handleSize={handleSize}
				count={selectedCount}
				page={params.page}
				size={params.size}
				handlePage={handlePage}
				filterTitle='Stakeholder'
			/>
		</div>
	);
};

export default SignatureHome;
